import { Col, Row } from "reactstrap";
import { ButtonsTitle } from "../../../../Constants/Constants";
import AudioCall from "./AudioCall";
import ConferenceCall from "./ConferenceCall";
import NoInternet from "./NoInternet";
import OnePersonCall from "./OnePersonCall";
import ReceiveAudioCall from "./ReceiveAudioCall";
import VideoCall from "./VideoCall";
import VideoCallConference from "./VideoCallConference";
import VideoCallHang from "./VideoCallHang";

const ModalButtons = () => {
  return (
    <section className="mb-5">
      <Row>
        <Col xs="12">
          <div className="element-card">
            <div className="element-card-header heading">
              <h2>{ButtonsTitle}</h2>
            </div>
            <div className="element-card-body popup-group">
              <AudioCall />
              <ReceiveAudioCall />
              <ConferenceCall />
              <OnePersonCall />
              <NoInternet />
              <VideoCall />
              <VideoCallHang />
              <VideoCallConference />
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default ModalButtons;
